export default {"src":"/_next/static/media/piechart_payment_history.6fb897f3.svg","height":250,"width":250};